import firebase from 'firebase';
import moment from 'moment';
import { withLastUpdated } from './dbHelpers.js';
let storage = firebase.storage();
let firestore = firebase.firestore();

// import { bytesToSize } from '../helper/helpers.js';

export async function uploadFile(file, jobID, procurement){
    let user = JSON.parse(sessionStorage.authUser);
    let success = false;
    let storageRef;
    let imageURL = null;
    let momentNow = Date.now();

    if(procurement){
        storageRef = storage.ref(`${sessionStorage.getItem('org')}/jobDocuments/${jobID}/procurement/${momentNow}-${file.name}`);
        await storageRef.put(file)
            .then(()=>{
                success = true;
            }).catch(err=>{
                console.log(`Error uploading file:`);
                console.log(err);
                success = false;
            });
        await storageRef.getDownloadURL()
            .then((url) => {
                imageURL = url;
            });

        return[success, imageURL, momentNow, file.name]
    }else{
        let uploadedFile = {};
        storageRef = storage.ref(`${sessionStorage.getItem('org')}/jobDocuments/${jobID}/${momentNow}-${file.name}`);
        //upload the document to cloud storage, get the url, and then upload it to firestore.
        await storageRef.put(file)
            .then(()=>{
                success = true;
            }).catch(err=>{
                console.log(`Error uploading file:`);
                console.log(err);
                success = false;
            });
        await storageRef.getDownloadURL()
            .then((url) => {
                imageURL = url;
            });

        if(success){
            await firestore
                .collection('jobDocuments')
                .add({
                    'fileName': momentNow + '-' + file.name,
                    'fileSize': file.size,
                    'date': new Date(),
                    'uploadedBy': {
                        name: user.displayName,
                        id: user.uid
                    },
                    'reviewed': false,
                    'image': imageURL,
                    'jobNum': jobID,
                    'org': sessionStorage.getItem('org')
                })
                .then(async (doc) => {
                    uploadedFile = {
                        'id': doc.id,
                        'fileName': momentNow + '-' + file.name,
                        'fileSize': file.size,
                        'date': moment(new Date).format('MMM DD YY hh:mm'),
                        'uploadedBy': {
                            name: user.displayName,
                            id: user.uid
                        },
                        'reviewed': false,
                        'image': imageURL,
                        'jobNum': jobID,
                        'org': sessionStorage.getItem('org')
                    }
                }).catch(err =>{
                    console.log(err);
                    success = false;
                });
        }
        return[success, imageURL, momentNow, uploadedFile]
    }
}

export async function uploadWorkOrderFile(file, workOrderID, repairs, repairIndex, repairDocuments){
    let user = JSON.parse(sessionStorage.authUser);
    let success = false;
    let storageRef;
    let imageURL = null;
    let momentNow = Date.now();


        let uploadedFile = {};
        storageRef = storage.ref(`${sessionStorage.getItem('org')}/workOrderDocuments/${workOrderID}/${momentNow}-${file.name}`);
        //upload the document to cloud storage, get the url, and then upload it to firestore.
        try {
            await storageRef.put(file)
            imageURL = await storageRef.getDownloadURL()

            success = true;

        } catch (error) {
            console.log(`Error uploading file: ${error}`);
            success = false;
        }

        if(success){
            uploadedFile = {
                file: {
                        size: file.size,
                        name: momentNow + '-' + file.name,
                        type: file.type
                        },
                date: new Date(),
                uploadedBy: {
                    name: user.displayName,
                    id: user.uid
                },
                url: imageURL,
            }
            if(!repairDocuments){
                repairDocuments = [uploadedFile]
            }
            else{
                repairDocuments.forEach((document)=>{
                    document.date = new Date(document.date);
                    document.file={
                        name: document.file.name,
                        size:document.file.size,
                        type:document.file.type
                    }
                })
                repairDocuments.push(uploadedFile)
            }
            repairs[repairIndex].documents = repairDocuments;
            delete repairs[repairIndex]._showDetails
            try {
                await firestore
                .collection('workOrders').doc(workOrderID).update(withLastUpdated({repairs:repairs}))
            } catch (error) {
                //TODO: delete the image from storage if the firestore update fails
                console.log(error);
                success = false;
            }

        }
        return[success, imageURL, momentNow, uploadedFile]

}

export async function deleteWorkOrderFile (fileName, workOrderID, repairs, repairIndex, repairDocuments){
    let success = false;
    let storageRef;
    let initialRepairDocuments;

        storageRef = storage.ref(`${sessionStorage.getItem('org')}/workOrderDocuments/${workOrderID}/${fileName}`);

        //delete the file, then delete the document from the database.
        await storageRef.delete()
            .then(()=>{
                success = true;
            }).catch(err=>{
                console.log(`Error deleting file:`);
                console.log(err);
                success = false;
            });

        if(success){
            initialRepairDocuments = JSON.parse(JSON.stringify(repairDocuments))
            repairDocuments.forEach((document)=>{
                document.date = new Date(document.date);
                document.file={
                    name: document.file.name,
                    size:document.file.size,
                    type:document.file.type
                }
            })
            let index = repairDocuments.findIndex((x)=>x.file.name === fileName);
            initialRepairDocuments.splice(index,1);
            repairDocuments.splice(index,1);
            repairs[repairIndex].documents = repairDocuments;

            try {
                await firestore
                .collection('workOrders')
                .doc(workOrderID)
                .update(withLastUpdated({repairs:repairs}))
            } catch (error) {
                //TODO: re-add the file to storage if the delete fails
                success = false;
                console.log(error);
            }


        }
        return [success, initialRepairDocuments ];
}

export async function getFilesForJob(jobID){

    let files = [];

    firestore
        .collection('jobDocuments')
        .where('jobNum', '==', Number(jobID))
        .where('org', '==', sessionStorage.getItem('org'))
        .orderBy('date', 'asc')
        .get()
        .then((documentSnapshot) => {
            documentSnapshot.forEach(doc =>{
                files.push({
                    'id': doc.id,
                    'fileName': doc.data().fileName,
                    'fileSize': doc.data().fileSize,
                    'date': moment(doc.data().date.toDate()).format('MMM DD YY hh:mm'),
                    'uploadedBy': doc.data().uploadedBy,
                    'reviewed': doc.data().reviewed,
                    'reviewedTime': doc.data().reviewedTime ? doc.data().reviewedTime : null,
                    'reviewedBy': doc.data().reviewedBy ? doc.data().reviewedBy : null,
                    'image': doc.data().image,
                    'jobNum': doc.data().jobNum,
                    'org': doc.data().jobNum
                });
            });
        }).catch(err =>{
            console.log(err);
        });

    // let files = [];
    // let storageRef = storage.ref(`${sessionStorage.getItem('org')}/jobDocuments/${jobID}`);
    // await  storageRef.list()
    //     .then((res) => {
    //         res.items.forEach(async file => {
    //             // console.log(file)
    //             await file.getMetadata()
    //                 .then(metadata=>{
                        // files.push({
                        //     'fileName': metadata.name,
                        //     'fileSize': bytesToSize(metadata.size)                        });
    //                 }).catch(err=>{
    //                     console.log(`Error getting file metadata:`);
    //                     console.log(err);
    //                 })
    //         });
    //     }).catch((error) => {
    //         // Uh-oh, an error occurred!
    //         console.log(`Error getting files for job ${jobID}: `);
    //         console.log(error)
    //     });
    return files;
}

export async function downloadFile (fileName, jobID, procurement){
    let downloadURL = null;
    let storageRef;
    if(procurement){
        storageRef = storage.ref(`${sessionStorage.getItem('org')}/jobDocuments/${jobID}/procurement/${fileName}`);

    }else{
        storageRef = storage.ref(`${sessionStorage.getItem('org')}/jobDocuments/${jobID}/${fileName}`);

    }
    await storageRef.getDownloadURL()
        .then((url) => {
            downloadURL = url;
        })
        .catch((error) => {
            console.log(error)
        });
    return downloadURL;
}

export async function deleteFile (fileName, jobID, procurement, docID){
    let success = false;
    let storageRef;

    if(procurement){
        storageRef = storage.ref(`${sessionStorage.getItem('org')}/jobDocuments/${jobID}/procurement/${fileName}`);
        await storageRef.delete()
            .then(()=>{
                success = true;
            }).catch(err=>{
                console.log(`Error deleting file:`);
                console.log(err);
            });
        return success;
    }
    else{
        storageRef = storage.ref(`${sessionStorage.getItem('org')}/jobDocuments/${jobID}/${fileName}`);

        //delete the file, then delete the document from the database.
        await storageRef.delete()
            .then(()=>{
                success = true;
            }).catch(err=>{
                console.log(`Error deleting file:`);
                console.log(err);
                success = false;
            });

        if(success){
            await firestore
                .collection('jobDocuments')
                .doc(docID)
                .delete()
                    .catch(err =>{
                        success = false;
                        console.log(err);
                    });
        }
        return success;
    }


}

export async function searchFiles(jobID, employeeID, startDate, endDate, ids=null){

    console.log(ids)
    let files = [];

    let query = firestore.collection('jobDocuments')
                .where('org', '==', sessionStorage.getItem('org'));

    //if ids are supplied, then we are search files directly by supplied ids. No need to do the rest of the checks.
    if(ids){
        //loop the ids and get the files.
        for(const id of ids){
            await firestore.collection('jobDocuments')
                .doc(id)
                .get()
                .then((doc) => {
                    files.push({
                        'id': doc.id,
                        'fileName': doc.data().fileName,
                        'fileSize': doc.data().fileSize,
                        'date': moment(doc.data().date.toDate()).format('MMM DD YY hh:mm'),
                        'uploadedBy': doc.data().uploadedBy,
                        'reviewed': doc.data().reviewed,
                        'reviewedBy': doc.data().reviewedBy,
                        'reviewedTime': doc.data().reviewedTime,
                        'image': doc.data().image,
                        'jobNum': doc.data().jobNum,
                        'org': doc.data().jobNum
                    });
                }).catch(err =>{
                    console.log(err);
                });
        }
    }else{
        if(jobID != null && jobID != ''){
            query = query.where('jobNum', '==', Number(jobID));
        }

        if(employeeID != null && employeeID != ''){
            query = query.where('uploadedBy.id', '==', employeeID);
        }

        if(startDate != null && startDate != ''){
            startDate = new Date(
                moment(startDate).startOf('day')
            );
            query = query.where('date', '>=', startDate);
        }

        if(endDate != null && endDate != ''){
            endDate = new Date(
                moment(endDate).endOf('day')
            );
            query = query.where('date', '<=', endDate);
        }
        await query
            .orderBy('date', 'asc')
            .get()
            .then((documentSnapshot) => {
                documentSnapshot.forEach(doc =>{
                    files.push({
                        'id': doc.id,
                        'fileName': doc.data().fileName,
                        'fileSize': doc.data().fileSize,
                        'date': moment(doc.data().date.toDate()).format('MMM DD YY hh:mm'),
                        'uploadedBy': doc.data().uploadedBy,
                        'reviewed': doc.data().reviewed,
                        'reviewedBy': doc.data().reviewedBy,
                        'reviewedTime': doc.data().reviewedTime,
                        'image': doc.data().image,
                        'jobNum': doc.data().jobNum,
                        'org': doc.data().jobNum
                    });
                });
            }).catch(err =>{
                console.log(err);
            });
    }

    return files;
}